var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 184,
    fill: "#8247E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 172C136.183 172 172 136.183 172 92C172 47.8172 136.183 12 92 12C47.8172 12 12 47.8172 12 92C12 136.183 47.8172 172 92 172Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_6242)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1003_6242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 51,
    width: 94,
    height: 82
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.923 51H45.1001V133H138.923V51Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1003_6242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.956 75.9673C114.245 74.9881 112.046 74.9881 110.092 75.9673L96.4092 84.0447L87.1248 89.1851L73.6867 97.2628C71.9763 98.2418 69.7773 98.2418 67.8227 97.2628L57.3166 90.8985C55.6063 89.9194 54.3846 87.9612 54.3846 85.7583V73.5194C54.3846 71.5612 55.3619 69.603 57.3166 68.3791L67.8227 62.2597C69.5331 61.2806 71.732 61.2806 73.6867 62.2597L84.1927 68.6239C85.9031 69.603 87.1248 71.5612 87.1248 73.7642V81.8418L96.4092 76.4567V68.1343C96.4092 66.1761 95.432 64.2179 93.4773 62.9941L73.9309 51.4896C72.2207 50.5105 70.0218 50.5105 68.0671 51.4896L48.0321 63.2388C46.0774 64.2179 45.1001 66.1761 45.1001 68.1343V91.1433C45.1001 93.1016 46.0774 95.0596 48.0321 96.2836L67.8227 107.788C69.5331 108.767 71.732 108.767 73.6867 107.788L87.1248 99.9553L96.4092 94.5702L109.847 86.7373C111.558 85.7583 113.757 85.7583 115.711 86.7373L126.217 92.8567C127.928 93.8359 129.149 95.7941 129.149 97.9971V110.236C129.149 112.194 128.172 114.152 126.217 115.376L115.956 121.496C114.245 122.475 112.046 122.475 110.092 121.496L99.5856 115.376C97.8752 114.397 96.6537 112.439 96.6537 110.236V102.403L87.3691 107.788V115.866C87.3691 117.824 88.3463 119.782 90.301 121.006L110.092 132.51C111.802 133.49 114.001 133.49 115.956 132.51L135.746 121.006C137.457 120.027 138.678 118.069 138.678 115.866V92.612C138.678 90.6538 137.701 88.6955 135.746 87.4716L115.956 75.9673Z",
    fill: "#8247E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_6242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 82,
    fill: "white",
    transform: "translate(45 51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.8a6509551fc05181ff26e8197277dab1.svg";
export { ForwardRef as ReactComponent };